import React, { useState } from "react";
import { refreshClinicToken } from "./api";

const TokenRefresher = () => {
  // Состояние формы
  const [formData, setFormData] = useState({
    clinic_id: "",
    client_secret: "",
    redirect_url: "",
  });

  // Состояние для отслеживания процесса отправки и результатов
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitResult, setSubmitResult] = useState(null);
  const [submitError, setSubmitError] = useState(null);

  // Обработчик изменения полей формы
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Обработчик отправки формы
  const handleSubmit = async (e) => {
    e.preventDefault();

    setIsSubmitting(true);
    setSubmitResult(null);
    setSubmitError(null);

    try {
      const response = await refreshClinicToken(
        formData.clinic_id,
        formData.client_secret,
        formData.redirect_url
      );
      setSubmitResult(response);
    } catch (error) {
      setSubmitError(error.message || "Произошла ошибка при обновлении токена");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-900 text-gray-100 p-6">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-3xl font-bold text-blue-400 mb-6">
          Обновление токена AmoCRM
        </h1>

        <div className="bg-gray-800 rounded-lg p-6 mb-8 shadow-lg">
          <form onSubmit={handleSubmit}>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
              {/* ID клиники */}
              <div className="md:col-span-2">
                <label
                  htmlFor="clinic_id"
                  className="block text-sm font-medium mb-2"
                >
                  ID клиники *
                </label>
                <input
                  id="clinic_id"
                  name="clinic_id"
                  type="text"
                  value={formData.clinic_id}
                  onChange={handleChange}
                  required
                  placeholder="ID клиники для обновления токена"
                  className="w-full bg-gray-700 border border-gray-600 rounded-md p-2 text-white focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
                <p className="text-xs text-gray-400 mt-1">
                  ID клиники, полученный при регистрации
                </p>
              </div>

              {/* Client Secret */}
              <div>
                <label
                  htmlFor="client_secret"
                  className="block text-sm font-medium mb-2"
                >
                  Client Secret
                </label>
                <input
                  id="client_secret"
                  name="client_secret"
                  type="text"
                  value={formData.client_secret}
                  onChange={handleChange}
                  placeholder="Client Secret из настроек интеграции (опционально)"
                  className="w-full bg-gray-700 border border-gray-600 rounded-md p-2 text-white focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
                <p className="text-xs text-gray-400 mt-1">
                  Оставьте пустым, чтобы использовать значение из настроек
                  клиники
                </p>
              </div>

              {/* URL перенаправления */}
              <div>
                <label
                  htmlFor="redirect_url"
                  className="block text-sm font-medium mb-2"
                >
                  URL перенаправления
                </label>
                <input
                  id="redirect_url"
                  name="redirect_url"
                  type="url"
                  value={formData.redirect_url}
                  onChange={handleChange}
                  placeholder="URL перенаправления (опционально)"
                  className="w-full bg-gray-700 border border-gray-600 rounded-md p-2 text-white focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
                <p className="text-xs text-gray-400 mt-1">
                  Оставьте пустым, чтобы использовать значение из настроек
                  клиники
                </p>
              </div>
            </div>

            {/* Кнопка отправки */}
            <div className="mt-8">
              <button
                type="submit"
                disabled={isSubmitting}
                className="bg-blue-600 hover:bg-blue-700 text-white font-medium py-3 px-6 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-200 disabled:opacity-50 w-full md:w-auto"
              >
                {isSubmitting ? "Обновление..." : "Обновить токен"}
              </button>
            </div>
          </form>

          {/* Результат отправки */}
          {submitResult && (
            <div className="mt-6 p-4 bg-green-900 text-white rounded-md">
              <h3 className="font-medium text-lg mb-2">
                Токен успешно обновлен!
              </h3>
              <p>
                Токен для клиники с ID <strong>{formData.clinic_id}</strong>{" "}
                успешно обновлен.
              </p>
              {submitResult.data?.expires_at && (
                <p className="mt-2">
                  Срок действия до:{" "}
                  <code className="bg-gray-800 px-2 py-1 rounded">
                    {new Date(
                      submitResult.data.expires_at * 1000
                    ).toLocaleString()}
                  </code>
                </p>
              )}
            </div>
          )}

          {/* Ошибка отправки */}
          {submitError && (
            <div className="mt-6 p-4 bg-red-900 text-white rounded-md">
              <h3 className="font-medium text-lg mb-2">
                Ошибка при обновлении токена
              </h3>
              <p>{submitError}</p>
            </div>
          )}

          {/* Информация по обновлению токенов */}
          <div className="mt-8 p-4 bg-gray-700 rounded-md text-gray-300 text-sm">
            <h3 className="font-medium text-base mb-3 text-gray-100">
              Информация по обновлению токенов:
            </h3>
            <ul className="space-y-2 list-disc pl-5">
              <li>
                <strong>Когда обновлять токены</strong> - Токены AmoCRM
                действуют в течение 24 часов с момента получения. После этого их
                необходимо обновить для продолжения доступа к API.
              </li>
              <li>
                <strong>Автоматическое обновление</strong> - Система пытается
                автоматически обновить токены при каждом запросе, однако иногда
                может потребоваться ручное обновление.
              </li>
              <li>
                <strong>Client Secret и URL перенаправления</strong> - эти поля
                необязательны, если они уже сохранены в настройках клиники.
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TokenRefresher;
